
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"934","height":"785","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.5 45C149.665-95.315 913.999 161 913.999 161 755.348-152.642 4.5 663 4.5 663c23-102.5 734.309-77.402 927.499 120","stroke":"#fff","stroke-width":"5","stroke-dasharray":"10 10"}})])
          )
        }
      }
    